var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VButtonIcon',_vm._g({directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.$t('edit'),
        placement: 'bottom',
    }),expression:"{\n        content: $t('edit'),\n        placement: 'bottom',\n    }"}],attrs:{"color":"green"}},_vm.$listeners),[_c('EditSVG')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }